(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
if (!customElements.get('serenia-cart-upsell')) {
  customElements.define('serenia-cart-upsell', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.select = this.querySelector('select');
      this.button = this.querySelector('button[type="submit"]');
      this.label = this.querySelector('[data-upsell-label]');
      this.originalLabel = this.label.innerHTML;
      this.select.addEventListener('change', () => {
        const option = this.select.selectedOptions[0];
        this.querySelector('[data-upsell-price]').textContent = option.dataset.price;
        const compare = this.querySelector('[data-upsell-compare]');
        compare.textContent = option.dataset.compare;
        compare.hidden = !option.dataset.compare;
        this.form.elements.quantity.value = option.dataset.min || '1';
        this.button.disabled = option.dataset.available !== 'true';
      });
      this.form.addEventListener('submit', (event) => this.add(event));
    }
    async add(event) {
      event.preventDefault();
      const drawer = this.closest('cart-drawer');
      if (drawer.dataset.upsellBusy || this.button.disabled || drawer.querySelector('.cart__items--disabled')) return;
      drawer.dataset.upsellBusy = 'true';
      const error = this.querySelector('.sc-upsell-error');
      const checkout = drawer.querySelector('#CartDrawer-Checkout');
      const cartItems = drawer.querySelector('cart-drawer-items');
      const previousCheckoutState = checkout?.disabled;
      if (checkout) checkout.disabled = true;
      if (cartItems) cartItems.inert = true;
      this.button.disabled = true;
      this.select.disabled = true;
      this.setAttribute('aria-busy', 'true');
      error.hidden = true;
      this.label.textContent = this.dataset.loading;
      let added = false;
      const root = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(window.routes?.cart_add_url || `${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: this.select.value, quantity: Number(this.form.elements.quantity.value) || 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || this.dataset.error);
        added = true;
        if (!data.sections?.['cart-drawer'] || !data.sections?.['cart-icon-bubble']) {
          const url = new URL(window.location.href);
          url.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
          const refreshed = await fetch(url, { headers: { Accept: 'application/json' } });
          if (!refreshed.ok) throw new Error(this.dataset.refreshError);
          data.sections = await refreshed.json();
        }
        if (!data.sections?.['cart-drawer'] || !data.sections?.['cart-icon-bubble']) throw new Error(this.dataset.refreshError);
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        if (typeof trapFocus === 'function') trapFocus(drawer.querySelector('#CartDrawer'), drawer.querySelector('.drawer__close'));
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', productVariantId: this.select.value, cartData: data });
        }
      } catch (failure) {
        error.textContent = added ? this.dataset.refreshError : failure.message || this.dataset.error;
        error.hidden = false;
        if (added) {
          this.querySelector('.sc-refresh-link').hidden = false;
          this.label.textContent = this.dataset.refreshError;
        }
      } finally {
        delete drawer.dataset.upsellBusy;
        if (cartItems?.isConnected) cartItems.inert = false;
        if (checkout?.isConnected) checkout.disabled = previousCheckoutState;
        if (this.isConnected) {
          this.removeAttribute('aria-busy');
          this.select.disabled = false;
          if (!added) {
            this.label.innerHTML = this.originalLabel;
            this.button.disabled = this.select.selectedOptions[0]?.dataset.available !== 'true';
          }
        }
      }
    }
  });
}
if (window.Shopify?.designMode && !window.sereniaCartEditorBound) {
  window.sereniaCartEditorBound = true;
  const reveal = (event) => {
    const section = event.target.closest('#shopify-section-cart-drawer');
    if (!section) return;
    const drawer = section.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  };
  document.addEventListener('shopify:section:load', (event) => {
    if (window.sereniaCartEditorWasOpen) reveal(event);
  });
  document.addEventListener('shopify:section:select', reveal);
  document.addEventListener('shopify:block:select', reveal);
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.id === 'shopify-section-cart-drawer') {
      window.sereniaCartEditorWasOpen = !!event.target.querySelector('cart-drawer.active');
      document.body.classList.remove('overflow-hidden');
      if (typeof removeTrapFocus === 'function') removeTrapFocus();
    }
  });
}


if (!customElements.get('sc-cart-timer')) {
  customElements.define('sc-cart-timer', class extends HTMLElement {
    connectedCallback() {
      this.clock = this.querySelector('[data-countdown-clock]');
      this.running = this.querySelector('[data-countdown-running]');
      this.expired = this.querySelector('[data-countdown-expired]');
      this.drawer = this.closest('cart-drawer');
      this.duration = Math.max(1, Number(this.dataset.minutes) || 10) * 60000;
      this.key = 'magicpaw-cart-timer-v1:' + this.dataset.block + ':' + this.dataset.minutes;
      this.hidden = true;
      if (this.dataset.editor === 'true') {
        this.hidden = false;
        this.display(this.duration);
        return;
      }
      this.check = () => {
        if (!this.drawer?.classList.contains('active') || this.drawer.classList.contains('is-empty')) return;
        if (this.started) return;
        this.start();
      };
      this.observer = new MutationObserver(this.check);
      if (this.drawer) this.observer.observe(this.drawer, { attributes:true, attributeFilter:['class'] });
      this.check();
    }
    start() {
      if (this.dataset.mode === 'deadline') {
        const value = (this.dataset.deadline || '').trim();
        if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/i.test(value)) return;
        this.end = Date.parse(value);
        if (!Number.isFinite(this.end)) return;
      } else {
        window.magicPawCartTimerEnds = window.magicPawCartTimerEnds || new Map();
        let saved = window.magicPawCartTimerEnds.get(this.key);
        try {
          const stored = Number(sessionStorage.getItem(this.key));
          if (Number.isFinite(stored) && stored > 0) saved = stored;
        } catch (error) {}
        this.end = Number.isFinite(saved) && saved > 0 ? saved : Date.now() + this.duration;
        window.magicPawCartTimerEnds.set(this.key, this.end);
        try { sessionStorage.setItem(this.key, String(this.end)); } catch (error) {}
      }
      this.started = true;
      this.hidden = false;
      this.tick();
      if (this.end > Date.now()) this.interval = window.setInterval(() => this.tick(), 1000);
    }
    display(milliseconds) {
      const seconds = Math.max(0, Math.ceil(milliseconds / 1000));
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const mm = String(hours ? minutes % 60 : minutes).padStart(2, '0');
      const ss = String(seconds % 60).padStart(2, '0');
      this.clock.textContent = hours ? String(hours).padStart(2, '0') + ':' + mm + ':' + ss : mm + ':' + ss;
    }
    tick() {
      const remaining = this.end - Date.now();
      this.display(remaining);
      if (remaining > 0) return;
      window.clearInterval(this.interval);
      if (this.dataset.expiry === 'hide') {
        this.hidden = true;
      } else {
        this.running.hidden = true;
        this.expired.hidden = false;
      }
    }
    disconnectedCallback() {
      window.clearInterval(this.interval);
      this.observer?.disconnect();
      this.started = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-header"] && !Shopify.designMode) return;
  try {
    
function pdpOpenHeaderCart(event) {
  if (!(event.target instanceof Element)) return;
  const trigger = event.target.closest('[data-pdp-cart-trigger]');
  if (!trigger) return;
  if (event.type === 'keydown' && event.key !== ' ' && event.code !== 'Space') return;
  if (event.type === 'click' && (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)) return;
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const open = () => {
    const currentDrawer = document.querySelector('cart-drawer');
    if (currentDrawer && typeof currentDrawer.open === 'function') currentDrawer.open(trigger);
  };
  if (typeof drawer.open === 'function') open();
  else customElements.whenDefined('cart-drawer').then(open);
}
document.addEventListener('click', pdpOpenHeaderCart, true);
document.addEventListener('keydown', pdpOpenHeaderCart, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-main-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pdp-kaching-info')) {
  customElements.define('pdp-kaching-info', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.start());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.unbind();
    }
    start() {
      this.main = this.closest('product-info');
      if (!this.main) return;
      this.output = this.querySelector('[data-pdp-info-output]');
      this.templates = new Map(Array.from(this.querySelectorAll('template[data-deal-id]')).map(template => [template.dataset.dealId, template]));
      this.observer = new MutationObserver(() => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.bind());
      });
      this.observer.observe(this.main, { childList: true, subtree: true });
      this.bind();
    }
    unbind() {
      if (!this.widget) return;
      this.widget.removeEventListener('deal-bar-selected', this.onSelected);
      this.widget.removeEventListener('kaching-bundles-block-loaded', this.onLoaded);
      this.widget = null;
    }
    bind() {
      const host = Array.from(this.main.querySelectorAll('kaching-bundle')).find(element => element.getAttribute('product-id') === this.dataset.productId);
      const widget = host?.querySelector('kaching-bundles-block');
      if (widget === this.widget) return;
      this.unbind();
      if (!widget) { this.hidden = true; return; }
      this.widget = widget;
      this.onSelected = event => this.show(event.detail?.dealBarId);
      this.onLoaded = () => this.sync();
      widget.addEventListener('deal-bar-selected', this.onSelected);
      widget.addEventListener('kaching-bundles-block-loaded', this.onLoaded);
      const anchor = host.closest('.shopify-app-block') || host;
      if (this.main.contains(anchor) && anchor.nextElementSibling !== this) {
        anchor.after(this);
        return;
      }
      this.sync();
    }
    sync() {
      if (!this.widget) return;
      const checked = this.widget.querySelector('[data-deal-bar-id] input[type="radio"]:checked');
      let id = this.widget.selectedDealBarId || checked?.closest('[data-deal-bar-id]')?.dataset.dealBarId;
      if (!id) {
        id = this.widget.dealBlock?.preselectedDealBarId;
        if (!id) {
          const config = Array.from(this.main.querySelectorAll('script.kaching-bundles-deal-block-settings')).find(element => element.dataset.productId === this.dataset.productId);
          if (config) {
            try { id = JSON.parse(config.textContent).preselectedDealBarId; } catch (_) { return; }
          }
        }
      }
      this.show(id);
    }
    show(id) {
      const template = this.templates.get(id);
      this.hidden = !template;
      if (!template) { this.currentDeal = null; return; }
      if (this.currentDeal === id && this.output.childElementCount) return;
      this.currentDeal = id;
      this.output.replaceChildren(template.content.cloneNode(true));
    }
  });
}


if (!customElements.get('pdp-desktop-thumbnails')) {
  customElements.define('pdp-desktop-thumbnails', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.controller?.abort();
    }
    initialize() {
      this.gallery = document.getElementById(this.dataset.galleryId);
      if (!this.gallery) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-pdp-media-target]');
        if (button && this.contains(button)) this.activate(button);
      }, options);
      this.addEventListener('keydown', (event) => {
        const keys = ['ArrowUp', 'ArrowDown', 'Home', 'End'];
        if (!keys.includes(event.key)) return;
        const buttons = Array.from(this.querySelectorAll('button')).filter(b => !b.hidden);
        const current = buttons.indexOf(event.target.closest('button'));
        if (current < 0) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : Math.max(0, Math.min(buttons.length - 1, current + (event.key === 'ArrowDown' ? 1 : -1)));
        buttons[next].focus({ preventScroll: true });
        this.activate(buttons[next]);
      }, options);
      this.observer = new MutationObserver(() => this.synchronize());
      this.observer.observe(this.gallery, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      this.synchronize();
    }
    activate(button) {
      const id = button.dataset.pdpMediaTarget;
      if (typeof this.gallery.setActiveMedia === 'function') {
        this.gallery.setActiveMedia(id, false);
      } else {
        const slides = this.gallery.querySelectorAll('[id^="GalleryViewer-"] [data-media-id]');
        const active = Array.from(slides).find(slide => slide.dataset.mediaId === id);
        if (!active) return;
        slides.forEach(slide => slide.classList.toggle('is-active', slide === active));
        window.pauseAllMedia?.();
        active.querySelector('deferred-media')?.loadContent(false);
      }
      this.synchronize();
    }
    synchronize() {
      const slides = Array.from(this.gallery.querySelectorAll('[id^="GalleryViewer-"] [data-media-id]'));
      const ids = new Set(slides.map(slide => slide.dataset.mediaId));
      const current = slides.find(slide => slide.classList.contains('is-active'))?.dataset.mediaId;
      const buttons = Array.from(this.querySelectorAll('[data-pdp-media-target]'));
      buttons.forEach(button => {
        button.hidden = !ids.has(button.dataset.pdpMediaTarget);
        if (button.dataset.pdpMediaTarget === current) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      this.hidden = buttons.filter(button => !button.hidden).length < 2;
      const active = buttons.find(button => button.dataset.pdpMediaTarget === current);
      if (!active || this.offsetParent === null) return;
      const box = active.getBoundingClientRect();
      const rail = this.getBoundingClientRect();
      if (box.top < rail.top) this.scrollTop -= rail.top - box.top;
      else if (box.bottom > rail.bottom) this.scrollTop += box.bottom - rail.bottom;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pdp-review-excerpt')) {
  customElements.define('pdp-review-excerpt', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
    }
    initialize() {
      if (this.initialized) return;
      const full = this.querySelector('[data-review-full]');
      const preview = this.querySelector('[data-review-preview]');
      const toggle = this.querySelector('[data-review-toggle]');
      if (!full || !preview || !toggle) return;
      this.initialized = true;
      const limit = Math.max(1, Number(this.dataset.limit) || 25);
      const words = full.innerText.trim().split(/\s+/u).filter(Boolean);
      if (words.length <= limit) return;
      preview.textContent = words.slice(0, limit).join(' ') + '…';
      preview.hidden = false;
      full.hidden = true;
      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        const expand = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(expand));
        full.hidden = !expand;
        preview.hidden = expand;
        toggle.textContent = expand ? this.dataset.less : this.dataset.more;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
